import React, { useState } from 'react';
import styles from './Card.module.scss';
import DownloadIcon from 'src/assets/icons/mat-download.svg?react';
import PrintIcon from 'src/assets/icons/material_print.svg?react';
import { ContentType, SllModule } from '@src/api/graphql-codegen';
import Button from '../button/Button';
import { downloadFile } from '@src/services/File';
import { getContentIcon } from '@src/utils/helpers';

type Props = {
  content: SllModule
  handleDownloadMaterial?: (content: SllModule) => void;
  handlePrintMaterial?: (content: SllModule) => void;
}

function SllMaterial(props: Props) {
  const { content, handleDownloadMaterial, handlePrintMaterial } = props

  const [downloading, setDownloading] = useState(false);

  const handleDownload = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    if (content.data) {
      setDownloading(true);
      downloadFile(content.data, 'pdf')
        .catch(() => {
          alert(`Can't download file.`);
        })
        .finally(() => {
          setDownloading(false);
        });
    }
  }

  const handlePrint = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    handlePrintMaterial?.(content)
  }

  const handleOpenMaterial = () => {
    handleDownloadMaterial?.(content)
  }
  const Icon = getContentIcon(content.type);

  return (
    <div className={styles.sllcard} onClick={handleOpenMaterial}>
      
      {Icon && <div className={styles.iconView}><Icon /></div>}
      <div className={styles.title}>{content.name}</div>
      {(content.type === ContentType.PDF || content.type === ContentType.SLIDE) && <Button label='' disabled={downloading} className={styles.printBtn} leftIcon={<PrintIcon className={styles.printIcon} />} onClick={handlePrint}/>}
      {(content.type === ContentType.PDF || content.type === ContentType.SLIDE) && <Button label='' disabled={downloading} className={styles.downloadBtn} leftIcon={<DownloadIcon />} onClick={handleDownload}/>}
    </div>
  );
}

export default SllMaterial

